import { FC } from 'react';

import { FeventListSummary } from '@shared/api/fevent/fevent.interface';

interface Props {
  summary?: FeventListSummary;
}

export const AgencyAdminBugoStatusBar: FC<Props> = function AgencyAdminBugoStatusBar({
  summary,
}: Props) {
  const totalFeventCount = summary?.totalFeventCount ?? 0;
  const totalShopOrderCount = summary?.totalShopOrderCount ?? 0;
  const sharedFeventCount = summary?.sharedFeventCount ?? 0;
  const unsharedFeventCount = summary?.unsharedFeventCount ?? 0;
  const sentBugoCount = summary?.sentBugoCount ?? 0;
  const unsentBugoCount = summary?.unsentBugoCount ?? 0;
  const fpb =
    totalFeventCount === 0 ? 0 : (totalShopOrderCount / totalFeventCount).toFixed(2);

  return (
    <div className="flex items-center py-2 font-bold theme-bg-1">
      <div className="flex-1 border-r pb-1">
        <div className="flex flex-col items-center space-y-1">
          <h6 className="theme-text-main">부고</h6>
          <p className="w-full text-center">{totalFeventCount.toLocaleString()}건</p>
        </div>
      </div>
      <div className="flex-1 border-r pb-1">
        <div className="flex flex-col items-center space-y-1">
          <h6 className="theme-text-main">화환</h6>
          <p className="w-full text-center">{totalShopOrderCount.toLocaleString()}건</p>
        </div>
      </div>
      <div className="flex-1 border-r pb-1">
        <div className="flex flex-col items-center space-y-1">
          <h6 className="theme-text-main">FPB</h6>
          <p className="w-full text-center">{fpb}</p>
        </div>
      </div>
      <div className="flex-1 border-r pb-1">
        <div className="flex flex-col items-center space-y-0.5">
          <h6 className="theme-text-main">공유</h6>
          <div className="w-full text-center">
            <p className="text-green-600">{sharedFeventCount.toLocaleString()}</p>
            <p className="text-red-500">{unsharedFeventCount.toLocaleString()}</p>
          </div>
        </div>
      </div>
      <div className="flex-1 pb-1">
        <div className="flex flex-col items-center space-y-0.5">
          <h6 className="theme-text-main">발송</h6>
          <div className="w-full text-center">
            <p className="text-green-600">{sentBugoCount.toLocaleString()}</p>
            <p className="text-red-500">{unsentBugoCount.toLocaleString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
